export default "__VITE_ASSET__AjGxRnEX__"